export const validateTournamentForm = (form) => {
  const errors = {};
  if (!form.nome.trim()) errors.nome = "Nome obrigatório";
  if (!form.buyin || isNaN(form.buyin) || Number(form.buyin) <= 0) {
    errors.buyin = "Buy-in inválido";
  }
  if (!form.plataforma) errors.plataforma = "Selecione a plataforma";
  return errors;
};

export const createRegistroValidator = (getTournament) => (form) => {
  const errors = {};
  if (!form.torneioId) errors.torneioId = "Selecione um torneio";
  if (!form.inscricoes || isNaN(form.inscricoes) || Number(form.inscricoes) < 1) {
    errors.inscricoes = "Mínimo 1";
  }

  const tournament = getTournament(form.torneioId);
  if (!form.plataforma && !tournament?.plataforma) {
    errors.plataforma = "Selecione a plataforma";
  }
  if (tournament?.modalidade === "SAT") {
    const ticketVal = form.tickets === "" ? 0 : Number(form.tickets);
    if (isNaN(ticketVal) || ticketVal < 0) {
      errors.tickets = "Valor inválido";
    }
  } else {
    const premioVal = form.premiacao === "" ? 0 : Number(form.premiacao);
    if (isNaN(premioVal) || premioVal < 0) {
      errors.premiacao = "Valor inválido";
    }
  }

  return errors;
};
